import { render, staticRenderFns } from "./ConfirmCancel.vue?vue&type=template&id=5b674d25&"
import script from "./ConfirmCancel.vue?vue&type=script&lang=js&"
export * from "./ConfirmCancel.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b674d25')) {
      api.createRecord('5b674d25', component.options)
    } else {
      api.reload('5b674d25', component.options)
    }
    module.hot.accept("./ConfirmCancel.vue?vue&type=template&id=5b674d25&", function () {
      api.rerender('5b674d25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ConfirmCancel.vue"
export default component.exports